import { CardItem } from '@components/SitemapReport/components/ProjectStats/components/StatCards/components/CardItem'
import type React from 'react'

import type {
  SectionChangeHandler,
  SectionStats,
  SectionType,
} from '../../../../types'

interface Props {
  stats: SectionStats
  activeSection: SectionType
  changes: boolean
  comparison: string
  onSectionChange: SectionChangeHandler
}

export const StatCards: React.FC<Props> = ({
  stats,
  activeSection,
  changes,
  comparison,
  onSectionChange,
}) => (
  <>
    <CardItem
      wide
      section="total"
      title="Total pages"
      stat={stats.total}
      activeSection={activeSection}
      changes={changes}
      comparison={comparison}
      onSectionChange={onSectionChange}
    />
    <CardItem
      section="indexed"
      title="Indexed"
      stat={stats.indexed}
      activeSection={activeSection}
      changes={changes}
      comparison={comparison}
      onSectionChange={onSectionChange}
    />
    <CardItem
      section="skipped"
      title="Skipped"
      stat={stats.skipped}
      activeSection={activeSection}
      changes={changes}
      comparison={comparison}
      onSectionChange={onSectionChange}
    />
  </>
)
